import { useEffect } from 'react';

/**
 * 页面切到 iOS 原生风格：在 <html> 上挂 `data-style="ios"`。
 *
 * 用在嵌进原生 App 的页面（如薯薯全能通）。分组底色、卡片色、分隔线、系统字体都在 `index.css` 的
 * `html[data-style='ios']` 里（跟随 `.dark`）；共享组件用 `ios:` 变体贴合原生列表 / 按钮样式。
 * 只在页面挂载期间生效，卸载时移除，不影响其它 App 的页面（如 bxy）。
 */
export function useGroupedSurface(): void {
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.style = 'ios';
    return () => {
      delete root.dataset.style;
    };
  }, []);
}
